import ReactPixel from 'react-facebook-pixel';
import Sticker from './Sticker';

const Tracker = {

    dev(){
        return window.location.hostname === 'localhost'
    },

    handleIndentValidation(indent){
        
        try{

            let enrollments = (indent.items || [])
                .filter(i => i.class === 'course')
                .map(i => this.trackEnrollment({
                    id: i.id,
                    product: i.course,
                    value: i.amount,
                    user: indent.user
                }))

            return {enrollments};

        }catch(e){
            console.log(e)
            return false;
        }
    },


    
    handleOrder(order){
        
        try{

            let enrollments = (order.items || [])
                .filter(i => i.type?.id === 'course')
                .map(i => this.trackEnrollment({
                    id: i.id,
                    product: i.product,
                    value: i.amount,
                    user: order.user
                }))

            return {enrollments};

        }catch(e){
            console.log(e)
            return false;
        }
    },



    trackEnrollment(data){

        try{

            /* STICKER LEARNYLIB */
            Sticker.track('enrollment', {
                id: data.id,
                product: data.product,
                value: data.value,
                user: data?.user
            });


            if(this.dev()){
                console.log('trackEnrollment', data);
                return false;
            }


            /* GOOGLE TAG MANAGER */
            window.dataLayer = window.dataLayer || []

            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: data.id,
                    affiliation: 'Plateforme e-learning LearnyLib',
                    value: parseFloat(data.value),
                    tax: 0.00,
                    currency: "EUR",
                    items: [{
                        item_id: data.product?.id,
                        item_name: data.product?.id,
                        affiliation: 'Plateforme e-learning LearnyLib',
                        currency: 'EUR',
                        item_brand: "LearnyLib",
                        item_category: data?.user?.category?.id,
                        item_variant: data.mode,
                        price: parseFloat(data.value || 0),
                        quantity: 1
                    }]
                },
                user_data: {
                    email: data.user?.email,
                    first_name: data.user?.firstName,
                    last_name: data.user?.lastName,
                    phone: data.user?.phone,
                    country_code: data.user?.country,
                    city: data.user?.city,
                    street: data.user?.address,
                    zip: data.user?.zip,
                    customer_id: data.user?.id,
                    orders_count: data.user?.enrollmentsCount
                }
            });

                

            /* FACEBOOK */
            ReactPixel.init('452223462061857', {}, {autoConfig: true, debug: false});

            ReactPixel.track('Purchase', {
                currency: 'EUR',
                value: data.value,
                product_name: data.product?.id,
                content_ids: [data.product?.id],
                content_name: data.product?.id,
                content_type: data.mode,
                content_category: data?.user?.category?.id,
                user: data?.user
            });


            return true;

        }catch(e){ 
            console.log(e)
            return false;
        }
    },
    

    trackRegistration(user){

        try{
    
            Sticker.track('new_account', {user});
    
            /* GOOGLE TAG MANAGER */
            window.dataLayer = window.dataLayer || []
    
            window.dataLayer.push({
                event: "generate_lead",
                user_data: {
                    email: user.email,
                    first_name: user.firstName,
                    last_name: user.lastName,
                    phone: user.phone,
                    country_code: user.country,
                    city: user.city,
                    street: user.address,
                    zip: user.zip,
                    customer_id: user.id
                }
            });
    
            return true;
    
        }catch(e){
            console.log(e)
            return false;
        }
    
    },

    
}

export default Tracker;

